<div class="master-container container-fluid">

  <!-- Header -->
  <site-header [site]="site" (logout)="logout()" (mobileToggleClicked)="openOffCanvas(offCanvasSidebar)"
    [navbarUserDropdownContent]="navbarUserDropdownContent">

  </site-header>


  <div class="toast-container top-0 {{this.languageSevice.language.dir == 'rtl' ? 'start-0' : 'end-0'}} p-3 position-fixed">
    @for (toast of this.toastService.toasts; track toast) {
      <ngb-toast header="{{toast.header}}" class="{{toast.class}}" (hidden)="this.toastService.remove(toast)" (click)="this.toastService.remove(toast)">
        {{toast.body}}
      </ngb-toast>
    }
  </div>

  <div class="wrapper">
    <!-- Sidebar -->
    @if (showDesktopSidebar) {
      <site-sidebar [showSpotterAppStorelinks]="false" [sidebarLayout]="sidebarLayout" [showTranslationDropdown]="false">
        <ng-container *ngTemplateOutlet="sidebarContentTemplate"></ng-container>
      </site-sidebar>
    }

    <!-- Content -->
    <div class="col main-section">
      <ng-content></ng-content>
    </div>
  </div>

  <!-- Footer -->
  <site-footer></site-footer>
</div>


<!-- Mobile Sidebar -->
<ng-template #offCanvasSidebar let-offcanvas>
  @if (!showDesktopSidebar) {
    <site-sidebar (routerNavigated)="offcanvas.close()" [mobile]="true" [showSpotterAppStorelinks]="false" [sidebarLayout]="sidebarLayout" [showTranslationDropdown]="false">
      <ng-container *ngTemplateOutlet="sidebarContentTemplate"></ng-container>
    </site-sidebar>
  }
</ng-template>


<!-- Server Error -->
<ng-template #serverErrorModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{'errors.server_error.title'|translate}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <p>{{'errors.server_error.description'|translate}}</p>
    <code>{{serverErrorString}}</code>
  </div>
</ng-template>

<!-- Server Down -->
<ng-template #serverDownModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{'errors.server_down.title'|translate}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <p>{{'errors.server_down.description'|translate}}</p>
  </div>
</ng-template>

<!-- Server Throttled -->
<ng-template #throttleModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{'errors.requests.title'|translate}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <p>{{'errors.requests.description'|translate}}</p>
    <p>{{'errors.requests.extra'|translate}}</p>
  </div>
</ng-template>